export default __webpack_public_path__ + "static/media/A_01_01_MAP_v02.dff18441.jpg";